import { STEP_PATHS, FLOWS } from '../step-constants';

export const getStepListConfig = ({ i18n, flow, currentStepId }) => {
  if (flow === FLOWS.MULTI_AUDIENCE_CAMPAIGNS && currentStepId === STEP_PATHS.MULTI_AD_MANAGER) {
    return ([{
      id: STEP_PATHS.MULTI_AD_MANAGER,
      title: i18n.getString(_TL_('Ads')),
    },
    {
      id: STEP_PATHS.AD_GROUP,
      title: i18n.getString(_TL_('Targets & ad group')),
    }, {
      id: STEP_PATHS.CAMPAIGN_CREATION,
      title: i18n.getString(_TL_('Budget & bid strategy')),
    }, {
      id: STEP_PATHS.SUMMARY,
      title: i18n.getString(_TL_('Summary')),
    }]);
  }

  if (flow === FLOWS.MULTI_AUDIENCE_CAMPAIGNS && currentStepId === STEP_PATHS.MULTI_NATIVE_AD) {
    return ([{
      id: STEP_PATHS.MULTI_NATIVE_AD,
      title: i18n.getString(_TL_('Ads')),
    },
    {
      id: STEP_PATHS.AD_GROUP,
      title: i18n.getString(_TL_('Targets & ad group')),
    }, {
      id: STEP_PATHS.CAMPAIGN_CREATION,
      title: i18n.getString(_TL_('Budget & bid strategy')),
    }, {
      id: STEP_PATHS.SUMMARY,
      title: i18n.getString(_TL_('Summary')),
    }]);
  } else if (flow === FLOWS.MULTI_AUDIENCE_CAMPAIGNS) {
    return ([{
      id: STEP_PATHS.MULTI_NATIVE_AD,
      title: i18n.getString(_TL_('Ads')),
    },
    {
      id: STEP_PATHS.AD_GROUP,
      title: i18n.getString(_TL_('Targets & ad group')),
    }, {
      id: STEP_PATHS.CAMPAIGN_CREATION,
      title: i18n.getString(_TL_('Budget & bid strategy')),
    }, {
      id: STEP_PATHS.SUMMARY,
      title: i18n.getString(_TL_('Summary')),
    }]);
  }

  if (flow === FLOWS.AUDIENCE_AD_GROUP_CREATION) {
    return ([{
      id: STEP_PATHS.AD_GROUP,
      title: i18n.getString(_TL_('Targets & ad group')),
    },
    {
      id: STEP_PATHS.NATIVE_AD,
      title: i18n.getString(_TL_('Ads')),
    }]);
  }

  if (flow === FLOWS.AUDIENCE_AD_GROUP_CTV_CREATION || flow === FLOWS.AUDIENCE_AD_GROUP_DEAL_CREATION) {
    return ([{
      id: STEP_PATHS.AD_GROUP,
      title: i18n.getString(_TL_('Targets & ad group')),
    },
    {
      id: STEP_PATHS.VIDEO_AD,
      title: i18n.getString(_TL_('Ads')),
    }]);
  }

  if (flow === FLOWS.AUDIENCE_AD_GROUP_MULTI_AD_CREATION && currentStepId === STEP_PATHS.MULTI_AD_MANAGER) {
    return ([{
      id: STEP_PATHS.AD_GROUP,
      title: i18n.getString(_TL_('Targets & ad group')),
    },
    {
      id: STEP_PATHS.MULTI_AD_MANAGER,
      title: i18n.getString(_TL_('Ads')),
    }]);
  }

  if (flow === FLOWS.AUDIENCE_AD_GROUP_MULTI_AD_CREATION && currentStepId === STEP_PATHS.MULTI_NATIVE_AD) {
    return ([{
      id: STEP_PATHS.AD_GROUP,
      title: i18n.getString(_TL_('Targets & ad group')),
    },
    {
      id: STEP_PATHS.MULTI_NATIVE_AD,
      title: i18n.getString(_TL_('Ads')),
    }]);
  }

  return ([{
    id: STEP_PATHS.VIDEO_AD,
    title: i18n.getString(_TL_('Ads')),
  },
  {
    id: STEP_PATHS.DISPLAY_AD,
    title: i18n.getString(_TL_('Ads')),
  },
  {
    id: STEP_PATHS.NATIVE_AD,
    title: i18n.getString(_TL_('Ads')),
  },
  {
    id: STEP_PATHS.AD_GROUP,
    title: i18n.getString(_TL_('Targets & ad group')),
  }, {
    id: STEP_PATHS.CAMPAIGN_CREATION,
    title: i18n.getString(_TL_('Budget & bid strategy')),
  }, {
    id: STEP_PATHS.SUMMARY,
    title: i18n.getString(_TL_('Summary')),
  }]
  );
};
